import React, { useEffect, useRef, useState } from 'react';
import './AboutComponent.scss';
import logo from './logo.png';

const AboutComponent = () => {
  const sectionRef = useRef(null);
  const [visible, setVisible] = useState(false);

  // Reveal-on-scroll using IntersectionObserver
  useEffect(() => {
    const el = sectionRef.current;
    if (!el) return;

    const io = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          io.disconnect(); // reveal once
        }
      },
      { rootMargin: '0px 0px -10% 0px', threshold: 0.25 }
    );

    io.observe(el);
    return () => io.disconnect();
  }, []);

  return (
    <section
      ref={sectionRef}
      className={`about ${visible ? 'is-visible' : ''}`}
      id="about"
      aria-label="About Plan My Guest"
    >
      {/* Left: Logo */}
      <div className="about__media">
        <div className="about__logoFrame" aria-hidden="true">
          <img className="about__logo" src={logo} alt="Plan My Guest logo" />
          <span className="about__ring about__ring--outer" />
          <span className="about__ring about__ring--inner" />
        </div>
      </div>

      {/* Right: Copy */}
      <div className="about__content">
        <h1 className="about__eyebrow">Who Are We?</h1>

        {/* <h2 className="about__title">
          Plan My Guest
        </h2> */}

        <div className="about__body">
          <p className="about__line">
            <strong>Plan My Guest</strong> helps you organize your wedding 
            guest list, collect RSVPs online, and plan seating effortlessly which have all in one place. We replace stressful spreadsheets with a modern, elegant system that saves time and adds joy to your planning journey.
          </p>
          <p className="about__line">
            We also create a personalized wedding website that doubles as
            your beautiful digital invitation. From first invite to the
            final seating plan, you can manage guests end-to-end track attendance, view real-time guest stats (attending, pending, not attending, liquor preferences), and keep everything perfectly organized in one dashboard.
          </p>
          <p className="about__line">
            Because you deserve to enjoy your wedding, not manage it.
          </p>
        </div>
      </div>
    </section>
  );
};

export default AboutComponent;
